export default __webpack_public_path__ + "static/media/the-unknown-album-moblie.f2c773e1.png";